// extracted by mini-css-extract-plugin
export default {"thumb":"poster-editor-tab-item-separator-panel-module__thumb--qgVtW"};